import { render, staticRenderFns } from "./top-brands.vue?vue&type=template&id=690eb822&"
import script from "./top-brands.vue?vue&type=script&lang=js&"
export * from "./top-brands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports